/**
 * Get the hubspot cookie value
 * @returns {string | undefined} - The value of the cookie or undefined if the cookie does not exist
 */
export const getHubspotCookie = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/, '$1')
